<template>
    <section class="newTable" v-if="options">
      <table class="table datatable table-striped" :id="prefix">
        <thead>
          <tr>
            <th v-if="options.checkAll" :width="options.checkBoxHasUser ? 120 : 60">
              <div class="checkbox checkbox-inline mr-0" v-if="multiple">
                <input 
                @click="checkAllClick = true"
                type="checkbox" 
                name="check-all" 
                id="check-all" 
                value="1" 
                v-model="checkAll">
                <label for="check-all"></label>
              </div>
              <span v-if="options.checkBoxHasUser">#</span>
            </th>
            <th
            v-for="(item, index) in options.columns"
            v-show="item.name != 'mkt_type' || (item.key == 'search_result' && is_open_mkt_type == 'Y') || (item.key == 'filter_result' && is_open_mkt_type == 'Y')"
            :key="`${prefix}-table-tr-${index}`"
            :width="setWidths(item, index, options, dataFrom)"
            :class="item.sorting ? 'sorting ' + (order.index==index + 1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '') : ''"
            @click="columnSorting(index + 1, item.label)"
            >
                <span v-html="item.label"></span>
                <span v-if="item.name=='mkt_type'" class="questionmark-icon" @click="$emit('openInfoModal')">?</span>
            </th>
          </tr>
        </thead>
        <tbody @scroll="scrollmethod" v-if="tableData.length" :class="options.scrollHeight ? 'block-height' : ''" :style="{height: options.scrollHeight + 'px'}">
          <tr v-for="(d, did) in tableData" :key="`${prefix}-table-td-${d.id}-${did}`">
            <template v-if="(did <= scrollPostion + scrollPostionOffset) || !dynamicLoading">
              <td v-if="options.checkAll" :width="options.checkBoxHasUser ? 120 : 60">
                <div style="min-height: 30px;">
                <div v-if="multiple" class="mr-0 checkbox checkbox-inline">
                  <input
                  @click="checkAllClick = false"
                  type="checkbox"
                  :name="`td-item${multiple? '[]' : ''}`"
                  :id="`${prefix}-check-${did}`"
                  :value="d.id"
                  v-model="selection"
                  :disabled="d.isPurePropertyCustomer"
                  @change="$emit('update', selection)">
                  <label :for="`${prefix}-check-${did}`"></label>
                </div>
                <div v-else class="mr-0 radio radio-inline">
                  <input
                  @click="checkAllClick = false"
                  type="radio"
                  :name="`td-item${multiple? '[]' : ''}`"
                  :id="`${prefix}-check-${did}`"
                  :value="d.id"
                  v-model="selection"
                  :disabled="d.isPurePropertyCustomer"
                  @change="$emit('update', selection)">
                  <label :for="`${prefix}-check-${did}`"></label>
                </div>
                
                <span v-if="options.checkBoxHasUser">
                  <span class="no">{{d.index}}</span>
                  <span class="info text-center" v-if="isShowSurvey">
                    <!-- 顯示問卷連結 -->
                    <level :lv="Number(d.vip_level)" />
                    <span v-if="d.id.includes('~')">
                      <avatar :gender="Number(d.sex)" :size="20" />
                    </span>
                    <span v-else>
                      <a style="cursor: pointer;" @click="$emit('openSurveyModal', d)">
                        <img v-if="d.customertype1=='1' && d.crm_highlight == '1' && Number(d.sex) == 1 " :src="`${BaseUrl}assets/common/gender_man_highlight.png`" width="20" />
                        <img v-else-if="d.customertype1=='1' && d.crm_highlight == '1' && Number(d.sex) == 2 " :src="`${BaseUrl}assets/common/gender_woman_highlight.png`" width="20" />
                        <img v-else-if="d.customertype1=='1' && d.crm_highlight == '1'" :src="`${BaseUrl}assets/common/gender_unknow_highlight.png`" width="20" />
                        <avatar v-else :gender="Number(d.sex)" :size="20" />
                      </a>
                    </span>
                  </span>
                  <span class="info text-center" v-else>
                    <!-- 不顯示問卷 -->
                    <level :lv="Number(d.vip_level)" />
                    <avatar :gender="Number(d.sex)" :size="20" />
                  </span>
                </span>
                </div>
              </td>
              <td
              v-for="(col, cid) in options.columns"
              v-show="col.name != 'mkt_type' || (col.key == 'search_result' && is_open_mkt_type == 'Y') || (col.key == 'filter_result' && is_open_mkt_type == 'Y')"
              :width="col.width || '*'"
              :key="`table-td-col-${cid}`">
                  <span v-if="col.template" v-html="col.template(d[col.name])"></span> <!--col.template(d[col.name])-->
                  <span v-else-if="col.name==='birthday'">
                    <div class="date">{{d[col.name] | dateFormat | getMaskBirthday }}</div>
                    <div class="age">
                      <!--<span v-if="!d.age || d.age == '0'">— —</span>-->
                      <span v-if=" d.age == '0' "><b>0歲</b></span>
                      <span v-else-if="d.age"><b>{{ d.age }}歲</b></span>                    
                      <span v-else><b>— —</b></span>
                    </div>
                  </span>
                  <span v-else-if="col.name==='idmark'">
                    <div class="list inline">
                      <span class="tag-box" :class="d[col.name].indexOf('1') > -1 ? 'active': ''">
                        要
                      </span>
                      <span class="tag-box" :class="d[col.name].indexOf('2') > -1 ? 'active': ''">
                        被
                      </span>
                      <span class="tag-box" :class="d[col.name].indexOf('3') > -1 ? 'active': ''">
                        意
                      </span>
                      <span class="tag-box" :class="d[col.name].indexOf('5') > -1 ? 'active': ''">
                        團
                      </span>
                      <span class="tag-box" :class="d[col.name].indexOf('6') > -1 ? 'active': ''">
                        借
                      </span>
                    </div>
                  </span>
                  <!-- <span v-else-if="col.name==='visit'">
                    <button class="btn btn-primary" style="font-size:12px;" v-html="d[col.name]"></button>
                  </span> -->
                  <span v-else-if="col.name==='visit'" :width="iPadWidth">
                    <span v-if="isBox" :width="iPadWidth">
                      <button 
                      v-if="!d.visit.csidno"
                      class="btn btn-primary visit-btn" 
                      @click="callBoxVisit(d)"
                      v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
                      <button 
                      v-else
                      class="btn btn-primary visit-btn" style="font-size:0.8rem;" 
                      @click="callBoxVisit(d)">{{ d.visit.str_date | dateFormat }}<br>{{ d.visit.str_time }}</button>
                      </span>
                    <span v-else :width="iPadWidth">
                      <button 
                      v-if="!d.visit.csidno"
                      class="btn btn-primary visit-btn" 
                      @click="$emit('scheduled-access', d)"
                      v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
                      <button 
                      v-else
                      class="btn btn-primary visit-btn" style="font-size:0.8rem;" 
                      @click="$emit('scheduled-access', d)">{{ d.visit.str_date | dateFormat }}<br>{{ d.visit.str_time }}</button>
                      </span>                
                  </span>            
                  <span v-else-if="col.name==='letter'">
                    <a @click="col.click(d, d['letter'][0].type)" class="link line-height-2 text-underline">親送專函</a><br />
                    <a @click="col.click(d, d['letter'][1].type)" class="link line-height-2 text-underline">郵寄專函</a>  
                  </span>
                  <span v-else-if="col.click && col.insuranceType !== 2">
                    <Tooltip
                      :position="d.index < 4 ? 'bottom' : 'top'"
                      :name="d.name"
                      :id="d.showid"
                      :mobile="d.mobile"
                      :phone="d.phone"
                      :birthday="d.birthday"
                      :address="d.address"
                    >
                      <a
                        @click="col.click(d)"
                        class="link text-underline"
                        title=""
                      >{{d[col.name] | getMaskName}}</a>
                      <span>{{isLostLife(d.is_lia)}}</span>
                    </Tooltip>
                  </span>
                  <span v-else-if="col.click && col.insuranceType == 2">
                    <Tooltip
                      :position="d.index < 4 ? 'bottom' : 'top'"
                      :name="d.name"
                      :id="d.showid"
                      :birthday="d.birthday"
                    >
                      <a
                        @click="col.click(d)"
                        class="link text-underline"
                        title=""
                      >{{d[col.name] | getMaskName}}</a>
                      <span>{{isLostLife(d.is_lia)}}</span>
                    </Tooltip>
                  </span>
                  <span v-else-if="col.name==='showid'">{{d[col.name] | getMaskID}}</span>
                  <span v-else-if="col.name==='mobile'">{{d[col.name] | getMaskMobile}}</span>
                  <span v-else-if="col.name==='phone'">{{d[col.name] | getMaskPhone}}</span>
                  <span v-else-if="col.name==='address'">{{d[col.name] | getMaskAddress}}</span>
                  <span v-else-if="col.name==='mkt_type'">
                    <span v-if="d.customertype1!='1'">
                      目前無泰好客資訊
                    </span>
                    <span v-else>
                      <span class="mkt-type-use"
                        :class="d.hos_mkt_level ? d.hos_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                      >住</span>
                      <span class="mkt-type-use"
                        :class="d.sur_mkt_level ? d.sur_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                      >手</span>
                      <span class="mkt-type-use"
                        :class="d.rei_mkt_level ? d.rei_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                      >實</span>
                      <span class="mkt-type-use"
                        :class="d.acc_mkt_level ? d.acc_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                      >意</span>
                      <span class="mkt-type-use"
                        :class="d.dd_mkt_level ? d.dd_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                      >重</span><br>
                      <span class="mkt-type-use"
                        :class="d.ltc_mkt_level ? d.ltc_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                      >長</span>
                      <span class="mkt-type-use"
                        :class="d.life_mkt_level ? d.life_mkt_level == '1' ? 'bg-green1' : 'bg-green2' : 'bg-gray'"
                      >壽</span>
                      <span class="mkt-type-use"
                        :class="d.sav_mkt_level ? d.sav_mkt_level == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
                      >儲</span>
                      <span class="mkt-type-use"
                        :class="d.inv_mkt_level ? d.inv_mkt_level == '1' ? 'bg-orange1' : 'bg-orange2' : 'bg-gray'"
                      >投</span>
                    </span>
                  </span>
                  <span v-else>{{d[col.name]}}</span>
              </td>
            </template>
          </tr>
          <tr v-if="scrollMessageLoading">
            <td colspan="8" class="text-center pt-3 pb-5">
              <h3>
                <div class="section-loading d-inline-block" style="height:20px; width:30px"></div>
                資料載入中
                <span>. . .</span>
              </h3>
            </td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
          </tr>
          
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="empty-block">
              
              <h3>
                <div v-if="!remoteDataMsg.includes('查無資料')" class="section-loading d-inline-block" style="height:20px; width:30px"></div>
                {{remoteDataMsg}}
              </h3>
            </td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
            <td style="display: none;"></td>
          </tr>
        </tbody>
      </table>
    </section>
</template>

<script>
import Level from '../Level'
import Avatar from '../Avatar'
import { commonMixin } from '../../mixins/common'
import { setTimeout } from 'timers';
import Tooltip from '@/desktop/components/ToolTip'
import moment from "moment"
import { mapGetters } from 'vuex';

const is_iPad = navigator.userAgent.match(/iPad/i) != null // 確認裝置是否為 iPad
let idmarkWidth = 117
if(is_iPad){
  idmarkWidth = 100
}

export default {
    name: "DataTable",
    mixins: [commonMixin],
    components: {Level, Avatar, Tooltip},
    props: {
        multiple: {
            type: Boolean,
            default: true
        },
        prefix:{
            type: String,
            default: ''
        },
        remoteDataMsg:{
            type: String,
            default: ''
        },
        currentPage:{
            type: Number,
            default: 0
        },
        totalpages:{
            type: Number,
            default: 0
        },
        scrollDataLoading:{
            type: Boolean,
            default: false
        },
        scrollMessageLoading:{
            type: Boolean,
            default: false
        },
        dynamicLoading: {
          type: Boolean,
          default: false
        },
        tableData: {
            type: Array,
            default: () => {
                return []
            }
        },
        dataFrom: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            default: () => {
                return null
            }
        },
        addPageStatus: {
            type: Boolean,
            default: false,
        },
        tableType: {
          type: String,
          default: 'default'
        },
        hasSearchBar:{
          type: Boolean,
          default: false
        },
        birthdaySortingType:{
          type: String,
          default: "1"
        },
        isShowSurvey: {
          type: Boolean,
          default: false
        },
        is_open_mkt_type: {
          type: String,
          default: "N"
        }
    },
    data() {
        return {
            tableList: this.tableData,
            order: {
                index: 0,
                asc: true
            },
            checkAll: 0,
            selection: [],
            currentWidth: 0,
            nowTime:0,
            lastTime:0,
            is_iPad: is_iPad,
            iPadWidth: idmarkWidth,
            checkAllClick: false,
            scrollPostion: 25, // 顯示當前位置
            scrollPostionOffset: 10, // 1次render筆數
            isToBottom: false, // 是否捲動到最下面
            isHandleHanlink: false //是否正在處理難字轉換
        }
    },
    watch: {
      tableData: function (val) {
        this.checkAll = false
        this.isToBottom = false
        if(!this.addPageStatus){
          this.selection = []
        }
        this.registerHanlink()
      },
      checkAll: function(val){
        if(val && this.checkAllClick) {
          this.selection = []
          this.tableData.forEach(data => {
            if(data.id !== '' && (data.isPurePropertyCustomer == false || data.isPurePropertyCustomer == undefined)){
              this.selection.push(data.id)
            }
          });
          this.$emit('update', this.selection)
          //this.$emit('updateall', this.checkAll)
        } else if(this.checkAllClick){
          if(!this.addPageStatus){
            this.selection = []
          }
          this.$emit('update', this.selection)
          //this.$emit('updateall', this.checkAll)
        }
        this.$emit('updateall', this.checkAll)
      },
      selection: function(){
        if(this.tableData.filter(item =>{return item.id != ''}).length !== this.selection.length && !this.checkAllClick){
          this.checkAll = false
        }else if(!this.checkAllClick){
          this.checkAll = true
        }
      },
    },
    computed: {
      ...mapGetters(['BaseUrl']),
      isBox() {
        //判斷是否為box
        return this.UserInfo.userType === 'box';
      }
    },
    methods: {
      scrollmethod(e){
        this.nowTime = +new Date()
        if(this.nowTime > this.lastTime + 150){
          this.lastTime = this.nowTime

          if (this.dynamicLoading) {
            //rate視為調整tempPostion的滾動位置的增加速率
            let rate = 0
            if(this.options.insuranceType == 1)
              rate = 69
            else
              rate = 35
            const tempPostion = (e.target.scrollTop / rate) + this.scrollPostionOffset;
            this.scrollPostion = Math.max(this.scrollPostion, tempPostion);

            if((!this.isToBottom)) {
              if(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= 50){
                //當滾動卷軸接近底端，縮小表格高度
                if(is_iPad){
                  if(this.hasSearchBar){
                    //畫面上有搜尋列
                    this.options.scrollHeight = $(window).height() -335
                  } else {
                    //畫面上無搜尋列
                    this.options.scrollHeight = $(window).height() -320
                  }
                } else {
                  this.options.scrollHeight = $(window).height() -420
                }
                this.isToBottom = true
              }
            }
            //處理難字
            if (!this.isToBottom && !this.isHandleHanlink) {
              this.isHandleHanlink = true
              setTimeout(() => {
                this.registerHanlink()
                this.isHandleHanlink = false
              }, 2000);
            }
          } else {
            if (!this.scrollDataLoading && e.target.scrollTop > (e.target.scrollHeight - e.target.clientHeight-200)) {  
              this.options.scrollLoadingAPI()
            }
          }
        }
      },
      isLostLife(is_lia){
        return is_lia == 'Y' ? ' (歿)' : ''
      },
      columnSorting (i, name) {
        if(name == "公司往來") {
          return; //公司往來
        }
        if(this.order.index===i) {
            this.order.asc = !this.order.asc
        }
        else {
            this.order.index = i
            this.order.asc = true
        }
        //data排序
        let sortOrder = -1;
        if (this.order.asc) {
          sortOrder = 1;
        }

        if(name == "身分證" || name == "手機" || name == "電話"|| name == "住家地址" || name == "泰好客" || name == "刪除倒數日") { 
          let propertyStr = { "身分證":"id", "手機":"mobile", "電話":"phone", "住家地址":"address", "泰好客":"mkt_score", "刪除倒數日":"cnt"};
          this.$nextTick(() => {
            this.tableData.sort(this.sortCompareFun(sortOrder, propertyStr[name]));
            this.tableData.forEach((item, index) => {
              item.index = `${index + 1}`;
            } );
          });
        } else if(name == "生日") {
          //年齡欄位
            this.$nextTick(() => {
            if(this.birthdaySortingType == "1") {
                this.tableData.sort(this.sortCompareFun(sortOrder, "age"));
                this.tableData.sort(this.sortCompareFun(sortOrder, "birthday"));
            } else {
                this.tableData.sort(this.dateCompareFun(sortOrder, "birthday"));
                this.tableData.sort(this.dateYearCompareFun(sortOrder, "age", "birthday"));
            }
            this.tableData.forEach((item, index) => {
              item.index = `${index + 1}`;
            } );
          });
        } else {
          //姓名欄位
          this.options.sortByName();
        }
      },
      resetPosition() {
        this.scrollPostion = 25;
        this.scrollPostionOffset = 10;
      },
      setWidths(item, index, options, dataFrom){
        if( options.columns.length == 3){
            if(item.name == 'birthday')
              return '*'
            else
              return 350      
        }
        if( dataFrom == 'TodayDeleteList'){
              return item.width    
        }
        return (index+1===options.columns.length && options.scrollHeight ? this.iPadWidth : item.width) || '*'      
      },
      //日期排序
      dateCompareFun(sortOrder, property) {
        return function(a, b) {
          let date_a = a[property] ? moment(a[property]).format("1800/MM/DD"):'01-01';
          let date_b = b[property] ? moment(b[property]).format("1800/MM/DD"):'01-01';
          let result = (moment(date_a).isBefore(date_b)) ? -1 : 1;
            return result * sortOrder;
        };
      },
      //月份排序
      dateYearCompareFun(sortOrder, age, birthday) {
        return function(a, b) {
          let date_a = a[birthday] ? moment(a[birthday]).format("MM/DD"):'01-01';
          let date_b = b[birthday] ? moment(b[birthday]).format("MM/DD"):'01-01';
          if((moment(date_a).isSame(date_b))) {
            let result = (a[age] < b[age]) ? -1 : (a[age] > b[age]) ? 1 : 0;
            return result * sortOrder;
          }
          return 0;
        }
      }
    },
    callBoxVisit(data) {
      //連至Box排訪
      this.boxVisit(data, this.categoryInfo);
    },
    mounted () {
        this.currentWidth = this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1)
        if(this.tableType === 'list-area' && !is_iPad) {
          this.iPadWidth = '167'
        }else if(this.tableType === 'list-area'){
          this.iPadWidth = '150'
        }
        if(this.tableType === 'substantial-contact-details' && !is_iPad) {
          this.iPadWidth = '97'
        }else if(this.tableType === 'substantial-contact-details'){
          this.iPadWidth = '80'
        }
    }
}
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }
  
  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;
    
    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, .5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, .5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}


.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.bg-green1 {
  background-color: rgb(0,128,0);
}

.bg-green2 {
  background-color: rgb(146,208,80);
}

.bg-gray {
  background-color: rgb(230,230,230);
}

.bg-orange1 {
  background-color: rgb(245, 136, 26);
}

.bg-orange2 {
  background-color: rgb(244, 177, 131);
}

.mkt-type-use {
  padding: 1px 4px;
  display: inline-block;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  color: #fff;
  font: 14px Arial, sans-serif;
  font-weight: 600;
  margin-bottom: 2px;
  margin-right: 3px;
}

.questionmark-icon {
  border-radius: 50%;
  border:2px solid #fff;
  width: 36px;
  height: 36px;
  padding: 1px 4px 1px 4px;
  color: #fff;
  text-align: center;
  font: 12px Arial, sans-serif;
  font-weight: 600;
  cursor: pointer;
}

.visit-btn {
  padding: 3px 10px;
}
</style>
